<template>
  <div class="div-cardplace">

    <div class="div-inner-cardplace">
      <div class="div-img-cardplace" @click="zuOwnPlace(hotelinfos.place_id)">

        <img
            v-if="hotelinfos.pictures_place.length >0"
            class="img-cardplace"
            :src='hotelinfos.pictures_place[0].url'
            alt="Foto-Hotel"
        />

      </div>


      <div class="div-inner-infos-cardplace">
        <div class="div-inner-infos1-cardplace" @click="zuOwnPlace(hotelinfos.place_id)">
          <div v-if="hotelinfos.stars >0 " style="height: 30px;">

            <v-rating
                v-model="hotelinfos.stars"
                background-color="transparent"
                color="#FFDF00"
                small
                readonly
            ></v-rating>
          </div>
          <div v-else style="height: 30px"></div>


          <div>
            <label class="label-hoteltitel-cardplace">
              {{ hotelinfos['place_name_' + pLang.toLowerCase()] }}
            </label>
          </div>


          <div class="div-location-cardplace">
            <v-icon small>mdi-map-marker</v-icon>
            <label>{{ hotelinfos.location.city }}, </label>
            <!--            <label>{{ hotelinfos.place.location.subregion }}, </label>-->
            <label>{{ getCountry(pLang.toUpperCase(), hotelinfos.location.country) }}</label>
          </div>


          <div>
            <div class="div-mealplan-cardplace">
              <v-icon>mdi-room-service</v-icon>
              <label>
                {{ getRatePlanByID(hotelinfos.rate_plans[0].rate_plan_id) }}
              </label>
            </div>
            <div>
              <label class="label-mealplan-cardplace" v-if="hotelinfos.rate_plans.length >1">
                {{ $t("Card.EbensoBuchbar") }}:

                <template v-for="(i, index) in hotelinfos.rate_plans">
                  <label v-if="index >0" class="label-mealplan-cardplace1">
                    {{ getRatePlanByID(i.rate_plan_id) }}<span v-if="index < hotelinfos.rate_plans.length-1">, </span>
                  </label>

                </template>
              </label>
            </div>
          </div>
        </div>

        <div style="text-align: center">
          <div>
            <div class="div-price-inner-cardplace">
              <v-icon small color="var(--Primary)">{{ currencyicon }}</v-icon>
              <label class="label-price-cardplace">
                {{ formatPrice(hotelinfos.min_price) }}*
              </label>
            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div class="div-priceinfo-cardplace" v-on="on">
                  *{{ $t("Card.Gesamtpreis") }}

                  <span v-if="hotelinfos.quantity > 1">
                    <br>
                    <span v-if="pLang !== 'TR'">{{ $t("Card.fuer") }} </span>
                    {{ hotelinfos.quantity }} {{ $t("Card.Zimmer") }}

                    <span v-if="pLang === 'TR'">{{ $t("Card.fuer") }}</span>

                  </span>
                  <v-icon small>mdi-information-outline</v-icon>
                </div>
              </template>
              <div class="tooltip-price-cardplace">
                {{ $t("Card.TTPreis1") }}
                <br>
                {{ $t("Card.TTPreis2") }}
              </div>
            </v-tooltip>
          </div>

          <div>
            <v-btn
                small
                color="var(--Primary)"
                class="vbtn-cardplace"
                @click="zuOwnPlace(hotelinfos.place_id)"
            >
              {{ $t("Button.Details") }}
            </v-btn>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>


<script>
import {formatPrice, getCurrencyIcon} from "@/util/currency";
import {getRatePlanByID} from "@/util/rateplansUtil";
import {getCountry} from "@/util/Countries";

export default {
  name: "CY_CardPlace",
  props: [
    'hotelinfos',
    'checkin',
    'checkout',
    'groups',
    'from',
    'pLang'
  ],
  data() {
    return {

      datetoday: new Date().toISOString(),
      currencyicon: getCurrencyIcon()
    }
  },
  methods: {
    getRatePlanByID,
    getCurrencyIcon,
    formatPrice,
    getCountry,
    zuOwnPlace(id) {

      if (this.from !== 'design') {
        let cyid = id.split("-");
        let r = this.$router.resolve({
          path: 'cy-place',
          query: {id: cyid[1], checkin: this.checkin, checkout: this.checkout, groups: this.groups}
        });

        window.open(r.href);

      }
    },


  },


  async created() {


  }

}

</script>

<style lang="css" scoped>
@import "../../css/CardPlace.css";
</style>
